import { render, staticRenderFns } from "./intelligentService.vue?vue&type=template&id=c142ef08&scoped=true"
import script from "./intelligentService.vue?vue&type=script&lang=js"
export * from "./intelligentService.vue?vue&type=script&lang=js"
import style0 from "./intelligentService.vue?vue&type=style&index=0&id=c142ef08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c142ef08",
  null
  
)

export default component.exports